
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/global-dating-trends",
      function () {
        return require("private-next-pages/[lang]/global-dating-trends.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/global-dating-trends"])
      });
    }
  